module.exports = __webpack_public_path__ + "img/baohu.dce5e2ef.png";